import axiosFetch from './config';

export const getDocumentTypes = async (countryId) => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: `/identity/documents/types?countryId=${countryId}`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const postDocuments = async(data)=>{
    let token = await localStorage.getItem('token')
    return axiosFetch({
      method:'POST',
      url: '/identity/documents/upload',
      data, 
      headers: {
        Authorization: 'Bearer ' + token,
      }
    })
}

export const getDocuments = async()=>{
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method:'GET',
    url: `/identity/documents`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

export const postAbort = async({provider="" ,verificationId=""})=>{
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method:'POST',
    url: `/kyc/process/abort`,
    headers: {
      Authorization: 'Bearer ' + token,
    },
    data:{
      provider,
      verificationId
    }
  })
}